import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className='footer'>
            <h1>QNA</h1>
           <div>
               <p className="question">
                   How React Works?
               </p>
               <p className="answer">
               React Is a declarative ,component based javascript library. react implement a virtual dom .which is a tree representaion of the actual dom. so when it needs to make changes in actual dom it compare changes between virtual dom and actual dom and update the specific element in actual dom. the updating process is happens by diff algorithm.
               </p>
           </div>
           <div>
               <p className="question">
                   Difference Between Props & State
               </p>
               <p className="answer">
               <strong>Props:</strong> Props allow you to pass data from one component to other components as an argument.Props Can Be Accessed by the child component. Props Are Read-only Component. Props Is Immutable.
               <br />
               <br />
               <strong>State:</strong> State holds information about the components. Each component can have its State.State Cannot be accessed by child components. The state is Mutable.
               </p>
           </div>
           <div>
               <p className="question">
                   How useState Works?
               </p>
               <p className="answer">
               useState is a react hook. useState returns an array, where the first element is the state variable and the second element is a function to update the value of the variable.  UseState takes the initial value of the state variable as an argument. It will only work for the first time for updating it conditionally we have to use the function. setState function is asynchronous. 
               </p>
           </div>
        </div>
    );
};

export default Footer;